<template>
  <div>
    <span 
      v-if="type=='button'"
    >
      <v-btn
        color="blue darken" 
        @click="dialog = true"
        :disabled="document.estatus.descripcion === 'Pendiente' || document.estatus.descripcion === 'Cancelado' || document.estatus.descripcion === 'Expirado'"
      >
        Generar Constancia
      </v-btn>
    </span>
    <v-list-item
      v-else-if="type=='list'"
      :disabled="document.estatus.descripcion === 'Pendiente' || document.estatus.descripcion === 'Cancelado' || document.estatus.descripcion === 'Expirado'"
      @click.stop="onClick"
    >
      <v-list-item-title>Generar Constancia</v-list-item-title>
    </v-list-item>
    <v-dialog v-model="dialog" persistent max-width="550">
        <v-card>
          <v-card-title class="headline">{{
            documentGenerateConstancies.questionConstancies
          }}</v-card-title>
          <v-card-text>{{
            documentGenerateConstancies.descriptionConstanciesText.replace('@', this.document.descripcion)
          }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              id="document_table__obtener_constancia__btn_si"
              color="accent"
              text
              @click="solicitarConstancia"
              :loading="loading"
              >{{ documentGenerateConstancies.positiveButtonText }}</v-btn
            >
            <v-btn  
              id="document_table__obtener_constancia__btn_no"
              color="red darken-1"
              text
              @click="dialog = false"
              :disabled="loading"
              >{{ documentGenerateConstancies.negativeButtonText }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    
  </div>
</template>

<script>
import { mdiTrashCanOutline, mdiMinusCircleOutline } from '@mdi/js'
import EmailServices from '../../documents/services/EmailService'
import { documentsData, documentsActions } from '../store/documentsHelpers'
import { pushNotification, messageErrorResponse } from '@/store/helpers'

export default {
  name: 'DocumentGenerateConstancy',
  props: {
    document: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'button'
    }
  },
  data() {
    return {
      icon: {
        document: mdiTrashCanOutline,
        download: mdiMinusCircleOutline
      },
      loading: false,
      dialog: false
    }
  },
  computed: {
    ...documentsData
  },
  methods: {
    ...documentsActions,
    onClick(){
      this.dialog = true
      this.$emit('click')
    },
    solicitarConstancia(){
      this.loading = true

      this.createDocumentConstancy(this.document.idDocumento)
        .then(result => {
          pushNotification(
            this.$store,
            result.data.successful.message,
            'info',
            'left',
            false,
            false
          )
          if (result.data.successful.code == 'CONSTANCIES-POST-200')
          {
            this.$emit('click')
            this.sendEmail(result.data.data.idDocumento)
          }
        })
        .catch(err => {
          pushNotification(
            this.$store,
            err.data.error.message,
            'error',
            'left',
            false,
            false
          )
        })
     },
    notificationError(msg) {
      pushNotification(
        this.$store,
        messageErrorResponse(msg) || this.msgDocumentServiceError,
        'error',
        'left',
        false,
        false
      )
    },
    sendEmail(idDocumento){
      const emailService = new EmailServices()
      emailService.sendEmailService(null, {idDocumento: idDocumento})
        .then(result =>{
          pushNotification(
            this.$store,
            result.data.successful.message,
            'info',
            'left',
            false,
            false
          )
        }).catch(error => {
          pushNotification(
            this.$store,
            error.response.data.error.message ||
            `Se presentó un error al enviar el correo electrónico.`,
            'error',
            'left',
            false,
            true
          )
        })
        .finally(() => {
          this.loading = false
          this.dialog = false
        })
    }
  }
}
</script>